module.exports = __webpack_public_path__ + "static/media/3.8970fe23.jpeg";